import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';
import Modal from 'react-modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import swal from 'sweetalert';
import { forceToMonFri } from '../../../components/DateFunction';
import { VisitInfo, FlightInfoRedux } from './FlightInfo';
import './RoomOverview.scss';
import './Multiselect.scss';
import TableBody from './Table/Body';
const { API_SERVER_URL, SF_URL, SF_PAGE_URL } = window;



export class RoomOverview extends React.Component {
    constructor(props) {
        super(props);
        const url = new URL(window.location.href);
        let dateFrom = moment(moment().format('YYYY-MM-DD'));
        if (url.searchParams.get('date')) {
            dateFrom = moment.tz(url.searchParams.get('date'), 'Asia/Makassar');
        }
        const pwd = url.searchParams.get('pwd');
        this.state = {
            shown: false,
            loading: false,
            flightData: [],
            allRooms: [],
            roomAllocations: [],
            filterShown: true,
            legendShown: false,
            dateFrom: moment(forceToMonFri(dateFrom.toDate())),
            dateTo: moment.tz(forceToMonFri(dateFrom.add('1', 'month').toDate()), 'Asia/Makassar'),
            flightModal: false,
            visitInfoModal: false,
            selectedVisit: {},
            selectedFlight: {},
        };
        this.onScroll = this.onScroll.bind(this);
        this.allRooms = this.allRooms.bind(this);
        this.searchRoom = this.searchRoom.bind(this);
        this.roomFilterChanged = this.roomFilterChanged.bind(this);
        this.datePickerRef = React.createRef();
        if (props.location.pathname.includes('/availability')) {
            document.body.style.backgroundImage = 'none';
            if (pwd !== 'AMA2020') {
                window.location = '/';
            }
        }
    }

    componentWillMount() {
        setTimeout(() => {
            const newDateFrom = forceToMonFri(this.state.dateFrom.format('YYYY-MM-DD'));
            this.setState({
                dateFrom: moment(newDateFrom),
            });
        }, 500);

    }

    componentDidMount() {
        window.addEventListener('scroll', this.onVerticalScroll.bind(this));
        this.allRooms();
        this.searchRoom();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onVerticalScroll.bind(this));
    }

    onVerticalScroll(e) {
        $(this.refs.headerStatic).css({
            visibility: window.scrollY > 400 ? 'visible' : 'hidden',
            top: window.scrollY - 220,
            left: 0,
            position: 'absolute',
            backgroundColor: '#fff',
        });
    }

    onScroll(e) {
        $(this.refs.colStatic).css({
            left: e.target.scrollLeft,
            visibility: e.target.scrollLeft > 100 ? 'visible' : 'hidden',
            top: 1,
        });
    }

    allRooms() {
        this.setState({
            loading: true,
        });
        $.ajax({
            url: `${API_SERVER_URL}ama/all-rooms`,
            crossDomain: true,
            type: 'GET',
            success: (response) => {
                this.setState({
                    allRooms: response.records,
                });
            },
        });
    }


    async searchRoom(e) {
        if (e) e.preventDefault();
        if (this.state.loading) return;
        const { dateFrom, dateTo } = this.state;
        try {
            this.setState({
                loading: true,
            });
            const requests = [
                fetch(`${API_SERVER_URL}ama/search?start_date=${dateFrom.format('YYYY-MM-DD')}&end_date=${dateTo.format('YYYY-MM-DD')}`, {
                    mode: 'cors',
                    method: 'get',
                }).then(o => o.json()).catch((err) => {
                    throw new Error(err.message);
                }),
                fetch(`${API_SERVER_URL}ama/search-flight?start_date=${dateFrom.format('YYYY-MM-DD')}&end_date=${dateTo.format('YYYY-MM-DD')}`, {
                    mode: 'cors',
                    method: 'get',
                }).then(o => o.json()).catch((err) => {
                    throw new Error(err.message);
                }),
            ];

            const timeout = new Promise((resolve, reject) => {
                setTimeout(() => reject(new Error('request timeout')), 5 * 1000);
            });
            const { 0: roomAllocations, 1: flightData } = await Promise.race([Promise.all(requests), timeout]);
            this.setState({
                flightData: flightData.records.filter(o => o.RecordType && (['IN-Flight', 'OUT-Flight'].indexOf(o.RecordType.Name)) > -1 && o.Flight_Type__c !== 'Alternative' && o.Flight_Status__c !== 'Cancelled'),
                loading: false,
                roomAllocations: roomAllocations.records,
            });
        } catch (error) {
            this.setState({
                loading: false,
            });
            swal({
                title: 'An error occured',
                text: error.message,
                type: 'error',
            });
        }
    }

    roomFilterChanged(e, x) {
        if (x === true) $(`.${e[0].value.replace(/\W+/g, '')}`).show();
        else $(`.${e[0].value.replace(/\W+/g, '')}`).hide();
    }

    render() {
        const { props } = this;
        const {
            legendShown, filterShown, dateFrom, dateTo, flightModal, visitInfoModal,
            allRooms, roomAllocations, flightData, selectedVisit,
        } = this.state;
        const dayDiff = dateTo.diff(dateFrom, 'day') + 3;
        // console.info(props.dateFrom, props.dateTo, dayDiff);
        const rooms = allRooms.map(room => ({
            // id : room.Id,
            value: room.RoomType__c,
            qty: room.RoomCount,
            selected: true,
        }));
        const flightColor = {
            Available: 'rgba(25, 126, 6, 1)',
            'Limited Seats': 'rgba(206, 147, 6, 1)',
            Full: 'rgba(180, 23, 0, 1)',
            'No Flight': '#222',
        };
        return (
            <div className="container-fluid" id="amaRoot">
                <div className="row">
                    <div
                        className="col-sm-12"
                        onClick={() => this.setState({ filterShown: !filterShown })}
                        role="button"
                        aria-pressed={false}
                        tabIndex={-1}
                        style={{ padding: 0 }}
                        onKeyDown={(e) => {
                            e.preventDefault();
                            if (e.keyCode === 32) this.setState({ filterShown: !filterShown });
                        }}
                    >
                        <h4 style={{ display: 'block', backgroundColor: '#10238C', padding: '10px 5px', color: '#fff', margin: 0 }}>
                            <i className="fa fa-filter" />
                            &nbsp;Filter
                            <div className="pull-right">
                                <i className={`fa ${filterShown ? 'fa-chevron-down' : 'fa-chevron-right'}`} color="#fff" style={{ fontSize: 20 }} />
                            </div>
                        </h4>
                    </div>
                </div>
                <div className="row">
                    <div className="panel panel-primary" style={{ textAlign: 'left', margin: '0', display: this.state.filterShown ? 'block' : 'none' }}>
                        <div className="panel-body">
                            <div className="col-sm-2">
                                <DatePicker
                                    selected={dateFrom.toDate()}
                                    selectsStart
                                    ref={this.datePickerRef}
                                    startDate={dateFrom.toDate()}
                                    endDate={dateTo.toDate()}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={(value) => {
                                        const newDateFrom = forceToMonFri(value);
                                        const newDateTo = forceToMonFri(moment(value).tz('Asia/Makassar').add(1, 'M').toDate());
                                        this.setState({ dateTo: moment(newDateTo), dateFrom: moment(newDateFrom) });
                                    }}
                                    className="form-control"
                                    showMonthDropdown
                                    showYearDropdown
                                />
                            </div>
                            <div className="col-sm-2">
                                <DatePicker
                                    selected={dateTo.toDate()}
                                    dateFormat="dd-MM-yyyy"
                                    selectsEnd
                                    startDate={dateFrom.toDate()}
                                    endDate={dateTo.toDate()}
                                    onChange={(value) => {
                                        this.setState({ dateTo: moment.tz(value, 'Asia/Makassar') });
                                    }}
                                    className="form-control"
                                    showMonthDropdown
                                    showYearDropdown
                                />
                            </div>
                            <div className="col-sm-2">
                                <button
                                    className="btn btn-info btn-small"
                                    disabled={this.state.loading}
                                    onClick={this.searchRoom}
                                > {this.state.loading ? <span><i className="fa fa-spinner fa-pulse fa-fw" /> Searching...</span>
                                    : <span><i className="fa fa-search" /> Search</span>}
                                </button>
                            </div>
                            <div className="col-sm-3 pull-right">
                                <a href={`${SF_URL}/006/e`} target="_blank" className="btn btn-success btn-small">
                                    <i className="fa fa-credit-card" /> New Opportunity
                                </a>
                            </div>
                            <div className="row">
                                <div className="col-sm-12" style={{ fontFamily: 'droid sans', fontSize: 11 }}>
                                    <p>*) you can only pick monday or friday</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix" />
                <div className="row">
                    <div
                        className="col-sm-12"
                        style={{ padding: 0 }}
                        onClick={() => this.setState({ legendShown: !legendShown })}
                        role="button"
                        aria-pressed={false}
                        tabIndex={-1}
                        onKeyDown={(e) => {
                            e.preventDefault();
                            if (e.keyCode === 32) this.setState({ legendShown: !legendShown });
                        }}
                    >
                        <h4 style={{ display: 'block', backgroundColor: '#5FC6D0', padding: '10px 5px', margin: 0 }}>
                            <i className="fa fa-map" /> Legend
                            <div className="pull-right">
                                <i className={`fa ${legendShown ? 'fa-chevron-down' : 'fa-chevron-right'}`} color="#10238C" style={{ fontSize: 20 }} />
                            </div>
                        </h4>
                    </div>
                    <div className="clearfix" />
                    <div className="panel panel-primary" style={{ textAlign: 'left', margin: '0', display: this.state.legendShown ? 'block' : 'none' }}>
                        <div className="panel-body">
                            <h4>Room Legend</h4>
                            <div className="col-sm-2 legend-item">
                                <span
                                    style={{
                                        display: 'inline-block',
                                        border: '3px solid #800080',
                                        width: 20,
                                        height: 20,
                                        marginRight: 10,
                                    }}
                                />
                                Share With Person Unknown
                            </div>
                            <div className="col-sm-2 legend-item">
                                <span
                                    style={{
                                        display: 'inline-block',
                                        border: '3px solid red',
                                        width: 20,
                                        height: 20,
                                        marginRight: 10,
                                    }}
                                />
                                Overbooking
                            </div>
                            <div className="col-sm-2 legend-item">
                                <span
                                    style={{
                                        display: 'inline-block',
                                        backgroundColor: 'blue',
                                        width: 20,
                                        height: 20,
                                        marginRight: 10,
                                    }}
                                />
                                Confirmed
                            </div>
                            <div className="col-sm-2 legend-item">
                                <span
                                    style={{
                                        display: 'inline-block',
                                        backgroundColor: '#2BDEFB',
                                        width: 20,
                                        height: 20,
                                        marginRight: 10,
                                    }}
                                />
                                Reserved
                            </div>
                            <div className="col-sm-2 legend-item">
                                <span
                                    style={{
                                        display: 'inline-block',
                                        backgroundColor: '#CCC',
                                        width: 20,
                                        height: 20,
                                        marginRight: 10,
                                    }}
                                />
                                Forecasted
                            </div>
                            <div className="clearfix" />
                            <h4>Flight Legend</h4>
                            {Object.keys(flightColor).map(key => (
                                <div className="col-sm-2 legend-item" key={key}>
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            backgroundColor: flightColor[key],
                                            width: 20,
                                            height: 20,
                                            marginRight: 10,
                                        }}
                                    />
                                    {key}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="table-responsive" onScroll={this.onScroll} style={{ position: 'relative' }}>
                        <table
                            className="table-fixed table-bordered"
                            style={{ visibility: this.state.shown === true ? 'visible' : 'hidden', zIndex: 9 }}
                            ref="colStatic"
                        >
                            <TableBody
                                allRooms={allRooms}
                                changeVisitModal={(isShown, selectedVisitData) => this.setState({ visitInfoModal: isShown, selectedVisit: selectedVisitData })}
                                changeFlightModal={(isShown, selectedFlight) => this.setState({ flightModal: isShown, selectedFlight })}
                                dateFrom={dateFrom}
                                dateTo={dateTo}
                                dayDiff={0}
                                flightData={flightData}
                                history={this.props.history}
                                roomAllocation={roomAllocations}
                            />
                        </table>
                        {/**
                            Disabled floating table
                            <table
                                className="table-bordered table"
                                ref="headerStatic"
                                style={{ display: 'block', zIndex: 8, visibility: this.state.shown ? 'visible' : 'hidden' }}
                            >
                                { printTableHeader(props, dayDiff, this.state.flightData, this.state.firstDate, true) }
                            </table>
                         */}

                        {this.state.shown === true ? this.state.staticTable : ''}
                        <table className="table table-bordered" style={{ display: 'block' }}>
                            <TableBody
                                allRooms={allRooms}
                                changeVisitModal={(isShown, selectedVisitData) => this.setState({ visitInfoModal: isShown, selectedVisit: selectedVisitData })}
                                changeFlightModal={(isShown, selectedFlight) => this.setState({ flightModal: isShown, selectedFlight })}
                                dateFrom={dateFrom}
                                dateTo={dateTo}
                                dayDiff={dayDiff}
                                flightData={flightData}
                                history={this.props.history}
                                roomAllocation={roomAllocations}
                            />
                        </table>
                    </div>
                </div>
                <Modal
                    id="flightModal"
                    overlayClassName="overlay-ama"
                    className="ama-modal"
                    isOpen={flightModal}
                    closeTimeoutMS={0}
                    ariaHideApp={false}
                    onRequestClose={() => this.setState({ flightModal: false })}
                >
                    <FlightInfoRedux flightInfo={this.state.selectedFlight} />
                    <div className="close-btn">
                        <button onClick={() => this.setState({ flightModal: false })} className="btn">
                            <i className="fa fa-times fa-2x" />
                        </button>
                    </div>
                </Modal>
                <Modal
                    id="visitModal"
                    overlayClassName="overlay-ama"
                    className="ama-modal"
                    isOpen={visitInfoModal}
                    closeTimeoutMS={0}
                    ariaHideApp={false}
                    onRequestClose={() => this.setState({ visitInfoModal: false })}
                >
                    <VisitInfo
                        visitData={selectedVisit}
                    />
                    <div className="close-btn">
                        <button onClick={() => this.setState({ visitInfoModal: false })} className="btn">
                            <i className="fa fa-times fa-2x" />
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

RoomOverview.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    // changeFlightModal: PropTypes.func.isRequired,
    // changeVisitModal: PropTypes.func.isRequired,
};

const customStyles = {
    content: {
        top: '10%',
        left: '25%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
};

export default RoomOverview;
